/**
 * The footer region the default web layout shells declare:
 *
 *   <footer class="pt-5 mt-5">
 *     <!--<div class="container"><h5>&copy; 2024 Your Company Name</h5>…</div>-->
 *     <!--<div class="text-center py-3"><a href="#" class="btn btn-light">Back to top</a></div>-->
 *   </footer>
 *
 * Both blocks are commented out in the design, so the region exists but renders
 * nothing — reproduced faithfully here rather than inventing copyright or
 * back-to-top chrome the design does not ask for. When the design enables either
 * block, fill it in here and every default layout picks it up.
 */
export default function AppFooter() {
  return <footer className="app-footer app-shell__footer pt-5 mt-5" />;
}
